import { Card, Form } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 80px 20px 30px 270px;
  @media only screen and (max-width: 1024px) {
    padding: 70px 10px;
    display: block;
    width: 100%;
  }
`;

export const StyledCard = styled(Card)`
  margin-top: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07);
  border: none;
`;

export const FormLabel = styled.span`
  font-weight: 500;
  color: #222;
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 18px !important;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

export const PreviewContainer = styled.div`
  margin-top: 40px;
  text-align: center;
  min-height: 120px;
`;

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 300px;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`;

export const TitleBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
`;

export const SubTitle = styled.div`
  color: #888;
  font-size: 15px;
  margin-top: 2px;
`;
